import type { UUID } from '@protector/utils/types';
import type { Product, ProductPage } from '@protector/entities/product/models';

export const ProductActionsTypes = {
  LOAD_PRODUCT: '[Product] Load Products',
  LOAD_PRODUCT_SUCCESS: '[Product] Load Products Success',
  LOAD_PRODUCT_FAILURE: '[Product] Load Products Failure',

  LOAD_PRODUCT_BY_IDS: '[Product] Load Products by IDS',
  LOAD_PRODUCT_BY_IDS_SUCCESS: '[Product] Load Products by IDS Success',
  LOAD_PRODUCT_BY_IDS_FAILURE: '[Product] Load Products by IDS Failure'
} as const;

export const LoadProducts = (companyId: UUID, propertyId?: UUID, pageSize?: number) => {
  return {
    type: ProductActionsTypes.LOAD_PRODUCT,
    payload: { companyId, propertyId, pageSize }
  };
};

export const LoadProductsSuccess = (productsPage: ProductPage) => {
  return {
    type: ProductActionsTypes.LOAD_PRODUCT_SUCCESS,
    payload: productsPage
  };
};

export const LoadProductsFailure = (error: string) => {
  return {
    type: ProductActionsTypes.LOAD_PRODUCT_FAILURE,
    payload: error
  };
};

export const LoadProductsByIds = (ids: UUID[]) => {
  return {
    type: ProductActionsTypes.LOAD_PRODUCT_BY_IDS,
    payload: ids
  };
};

export const LoadProductsByIdsSuccess = (products: Product[]) => {
  return {
    type: ProductActionsTypes.LOAD_PRODUCT_BY_IDS_SUCCESS,
    payload: products
  };
};
